export const escapeMarkdown = (value: string) =>
  (value || "").replace(/[-_*[\](){}`#+.!\\]/g, "\\$&")
